/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Help_Building_Data_AccessInputs */



/**
* | output |
* | --- |
* | "Access to building data:" |
*
* @param {Users_Help_Building_Data_AccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const users_help_building_data_access = /** @type {((inputs?: Users_Help_Building_Data_AccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Help_Building_Data_AccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Access to building data:")
	return /** @type {LocalizedString} */ ("Accès aux données du bâtiment :")
});